import { filtersSlice } from './reducer';

export const { changeFilter, clear, clearList } = filtersSlice.actions;
